<template>
        <main class="content">
            <div class="row">
                <h1>
                    Schedule
                </h1>
            </div>
            <div class="topBar">
                <div class="topBar--item_left">
                    <div class="input_text">
                        <v-select v-model="wallId" :searchable="false" placeholder="Click to select a wall" :options="walls"></v-select>
                    </div>
                    <button class="btn btn_blue u-mr1" @click="filter()">
                        Filter
                    </button>
                    <button v-if="query.wallId" class="btn btn_blue" @click="reset()">
                        X
                    </button>
                </div>
                <div class="topBar--item_right">
                    <router-link to="/schedule/add" class="btn btn_blue">
                      Schedule new video
                    </router-link>
                </div>
            </div>
            <div class="table">
                <Message v-if="errorMessage" :message-content="errorMessage" message-status="error"></Message>
                <div class="table--row table--row_header">
                    
                    <div class="table--col" v-bind:class= "getSortClasses('slotDate')" @click="sort('slotDate')" style="max-width:138px">
                        <div class="table--col-title">
                            Timeslot
                            <div class="table--col-arrows">
                                <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                                    </path>
                                </svg>
                                <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                                    </path>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="table--col u-unclickable" style="max-width:172px" v-bind:class= "getSortClasses('wall.name')" @click="sort('wall.name')">
                        <div class="table--col-title">
                            Wall
                            <div class="table--col-arrows">
                                <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                                    </path>
                                </svg>
                                <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                                    </path>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="table--col" style="max-width:126px">
                        <div class="table--col-title">
                            Video
                        </div>
                    </div>
                    <div class="table--col" style="max-width:208px" v-bind:class= "getSortClasses('videoDetails.title')" @click="sort('videoDetails.title')">
                        <div class="table--col-title">
                            Information
                            <div class="table--col-arrows">
                                <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                                    </path>
                                </svg>
                                <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                                    </path>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="table--col" style="max-width:280px" v-bind:class= "getSortClasses('user.first_name')" @click="sort('user.first_name')">
                        <div class="table--col-title">
                            User
                            <div class="table--col-arrows">
                                <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                                    </path>
                                </svg>
                                <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                                    </path>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="table--col" style="max-width:297px" v-bind:class= "getSortClasses('status')" @click="sort('status')">
                        <div class="table--col-row">
                        </div>
                        <div class="table--col-title">
                            Status
                            <div class="table--col-arrows">
                                <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                                    </path>
                                </svg>
                                <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                                    </path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table--row" v-for="video in videos">
                    <div class="table--col" style="max-width:138px">
                        <strong>
                            {{video.startsAt | moment("tz", video.wall.city.timezone, "MM/DD/YY")}}
                        </strong>
                        <span>
                            {{video.startsAt | moment("tz", video.wall.city.timezone, "hh:mma")}}
                        </span>
                    </div>
                    <div class="table--col" style="max-width:172px">
                        <strong>
                            {{video.wall.name}}
                        </strong>
                        <span>
                            {{video.wall.city.name}}
                        </span>
                    </div>
                    <div class="table--col" style="max-width:126px">
                        <a class="table--video" :href="video.videoDetails.link" target="_blank" v-bind:style="{ 'background-image': 'url(' + video.videoDetails.thumbnailUrl + ')' }">
                        </a>
                    </div>
                    <div class="table--col" style="max-width:208px">
                        <strong>
                            {{video.videoDetails.title}}
                        </strong>
                        <span>
                            {{video.videoDetails.duration | duration}}
                        </span>
                    </div>
                    <div class="table--col" style="max-width:280px">
                        <div class="table--col-user">
                            <div class="table--col-user-img" v-bind:style="{ 'background-image': 'url(' + (video.user.picture ? video.user.picture.url : 'http://via.placeholder.com/40x40') + '?api_key=' + $parent.api_key + ')' }"></div>
                            <strong>
                                {{video.user.firstName}} {{video.user.lastName}}<br>
                                <span>{{video.user.email}}</span>
                            </strong>
                        </div>
                    </div>
                    <div class="table--col" style="max-width:297px">
                        <div class="table--col-row">
                            <button class="btn btn_green btn_done">
                                <svg height="8" viewbox="0 0 11 8" width="11" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11 1.647L9.25 0l-5 4.706-2.5-2.353L0 4l4.25 4" fill-rule="nonzero">
                                    </path>
                                </svg>
                                Scheduled
                            </button>
                            <button class="btn btn_red" v-if="video.status == 'approved'" @click="wantToCancel(video)">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <a class="btn btn_green u-fleft" @click="fetchResource()" v-if="nextPage">
                Load more
            </a>
            <confirm resource="a scheduled video" :visible.sync="alertVisible"></confirm>
            <loading :visible.sync="loadingVisible"></loading>
        </main>
</template>

<script>
import * as HttpService from '../../services/http.service'
import * as ListResource from '../../mixins/listResource.mixin'

import Loading from '../Loading.vue'
import vSelect from "vue-select"
import Confirm from '../Modals/modal_confirm'
import Message from '../Message.vue'

export default {
  name: 'Schedule',
  components: {
      Loading,
      vSelect,
      Message,
      Confirm},
  mixins: [ListResource],
  data () {
    return {
      model: 'videos',
      resource: 'videos/scheduled',
      query: this.$route.query,
      videoToCancel: '',
      videos: [],
      walls: [],
      wallId: '',
      sortOrder: 'asc',
      sortAttribute: 'name',
      alertVisible: false,
      errorMessage: '',
      watching: false
    }
  },
  created(){
    var self = this;
    HttpService.index('walls', {}, function(response, error){
      self.walls = response.result.data;
      self.walls = self.walls.map(item => {
        return {value: item.id, label: item.name}
      });

      if(self.query.wallId){
        self.wallId = self.walls.find(item => item.value == self.query.wallId);
      }
    });
  },
  mounted(){
    this.refresh();
  },
  beforeDestroy(){
    clearInterval(this.watching);
  },
  methods: {
    wantToCancel(video) {
        this.videoToCancel = video
        this.confirmToggle()
    },
    confirmToggle() {
      this.alertVisible = !this.alertVisible;
    },
    confirmAccept() {
      this.alertVisible = false;
      this.doCancel();
    },
    doCancel(){
      var self = this;
      if (self.videoToCancel != null) {
        HttpService.remove('videos/' + self.videoToCancel.id, '', function(res, err){
            if (err) {
                self.errorMessage = err.message;
            } else {
                self.errorMessage = '';
                self.videoToCancel = null;
                self.fetchResource();
            }
        });
      }
    },
    filter(){
      if(this.wallId && this.wallId.value && this.wallId.value !== this.query.wallId){
        window.open('#/schedule?wallId=' + this.wallId.value, '_blank');
      }
      return false;
    },
    reset(){
      this.query = {};
      this.wallId = null;
      this.fetchResource();
    },
    refresh(){
      var self = this;
      self.watching = setInterval(function(){
        self.fetchResource();
      }, 20000);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Schedule.vue?496344e2